import { IReviewState } from "./interfaces";

export const DEFAULT_REVIEW_POPUP_STATE: IReviewState = {
	create: false,
	edit: false,
	alternatives: false,
};
